import scrollToAnchor from '../modules/scrollToAnchor';
import vars from '../helpers';

function getHeight(elem) {
	return elem.getBoundingClientRect().height;
}

function getOuterHeight(elem) {
	let elHeight = elem.getBoundingClientRect().height;
	elHeight += parseInt(window.getComputedStyle(elem).getPropertyValue('margin-bottom'), 10);

	return elHeight;
}

function getInnerHeight(elem) {
	let elHeight = elem.getBoundingClientRect().height;
	elHeight -= parseInt(window.getComputedStyle(elem).getPropertyValue('margin-bottom'), 10);

	return elHeight;
}

function changeHeight(el, height) {

	if (el.classList.contains('is-visible')) {
		el.style.height = `${height}px`;
	} else {
		el.style.height = 0;
	}
}

function toggleClass(dropdownBtn) {
	const dropdownContent = dropdownBtn.parentNode.querySelector('.drop-down-content');
	const parent = dropdownContent.parentNode;
	const contentHeight = getHeight(dropdownContent);
	const submenu = dropdownBtn.classList.contains('service__side-subtitle');

	dropdownBtn.classList.toggle('is-active');
	parent.classList.toggle('is-visible');

	if (submenu) {
		const submenuParent = dropdownContent.parentNode.parentNode.closest('.service__side-submenu-list');
		const submenuContentHeight = getOuterHeight(submenuParent);
		const submenuContentHeightClose = getInnerHeight(submenuParent);

		changeHeight(parent, contentHeight);

		if (dropdownBtn.classList.contains('is-active')) {

			setTimeout(() => {
				changeHeight(submenuParent, submenuContentHeight + contentHeight);
			}, 300);

		} else {
			
			setTimeout(() => {
				changeHeight(submenuParent, submenuContentHeightClose - contentHeight);
			}, 300);

		}
	} else {
		changeHeight(parent, contentHeight);
	}
}

function closeAllDropdown(dropdownBtn) {
	const allDropdown = document.querySelectorAll('.drop-down-js');

	allDropdown.forEach((el) => {
		if (el.classList.contains('is-active') && el !== dropdownBtn) {
			if (!el.parentNode.contains(dropdownBtn)) {
				toggleClass(el);
			}
		}
	});
}

function replaceActiveLabel(formDropdown, targetLable) {
	const allLabel = formDropdown.querySelectorAll('label');

	allLabel.forEach((el) => {
		el.classList.remove('is-active');
	});

	targetLable.classList.add('is-active');
}

function replacePlaceHolder(e) {
	const formDropdown = e.target.closest('.form__item');
	const btn = formDropdown.querySelector('.drop-down-js');
	const targetLable = formDropdown.querySelector(`[for="${e.target.id}"]`);

	formDropdown.querySelectorAll('label').forEach((el) => {
		el.classList.remove('is-active');
	});
	targetLable.classList.add('is-active');
	btn.querySelector('span').textContent = e.target.dataset.name;

	btn.click();

	replaceActiveLabel(formDropdown, targetLable);
}

function checkActiveSubtitle() {
	const subtitleActive = document.querySelector('.service__side-subtitle.is-active');

	if (subtitleActive) {
		const submenu = subtitleActive.nextElementSibling;
		const submenuList = submenu && submenu.classList.contains('service__side-submenu-list');

		if (submenuList) {
			// set child list height
			const listContent = submenu.querySelector('.drop-down-content');
			const submenuHeight = getHeight(listContent);

			submenu.classList.add('is-visible');
			changeHeight(submenu, submenuHeight);

			// set parent list height
			const parentList = subtitleActive.closest('.service__side-submenu-list');
			const dropdontContent = subtitleActive.closest('.drop-down-content');
			const height = getOuterHeight(dropdontContent);

			const submenuOpen = submenu.querySelector('.service-link.is-active');

			if (!submenuOpen) {
				changeHeight(parentList, height + submenuHeight);
			} else {
				const parentLinkActive = dropdontContent.querySelector('.service-link.is-active');

				parentLinkActive.classList.remove('is-active');
			}
		}
	}
}

function checkActiveMenu() {
	const sideItems = document.getElementsByClassName('service__side-item');
	const submenuListMenuActive = document.querySelector('.service__side-submenu-list .service__side-submenu-list .service-link.is-active');

	if (submenuListMenuActive) {
		const el = submenuListMenuActive.closest('.service__side-item');
		const dropdownBtn = el.querySelector('.service__side-subtitle.drop-down-js');
		const list = submenuListMenuActive.closest('.service__side-submenu-list');

		toggleClass(dropdownBtn);

		setTimeout(() => {
			list.classList.remove('is-load');
		}, 1000);
	}

	if (sideItems.length) {
		sideItems.forEach((el) => {
			if (el.querySelector('.is-active')) {
				const title = el.querySelector('.service__side-title');
				const dropdontContent = el.querySelector('.drop-down-content');
				const height = getHeight(dropdontContent);
				const submenuList = el.querySelector('.service__side-submenu-list');

				submenuList.classList.add('is-visible');
				title.classList.add('is-active');
				changeHeight(submenuList, height);

				setTimeout(() => {
					submenuList.classList.remove('is-load');
				}, 1000);
			}
		});
	}

	checkActiveSubtitle();
}

function init() {
	const dropDownInput = document.querySelectorAll('[name="preference"]');

	window.addEventListener('click', (e) => {
		const dropdownBtn = e.target.closest('.drop-down-js');

		if (dropdownBtn || e.target.classList.contains('drop-down-js')) {
			if (dropdownBtn.classList.contains('service-link') && dropdownBtn.classList.contains('is-active')) {
				e.preventDefault();
			}

			if (vars.isMobile()) {
				if (e.target.closest('.service__side-block')) {
					const sideBlock = document.querySelector('.service__side-block');
					const sideTitle = sideBlock.querySelector('.service__side-item .service__side-title');
					const subtitle = e.target.classList.contains('service__side-subtitle');

					// console.log(sideTitle)

					if (sideTitle.classList.contains('is-active') && !subtitle) {
						window.scrollTo(0, 0);

						setTimeout(() => {
							closeAllDropdown(dropdownBtn);
						}, 250);
					} else {
						closeAllDropdown(dropdownBtn);
					}
				}
			}

			if (!vars.isMobile() && !e.target.closest('.service__main-content-cms')) {
				closeAllDropdown(dropdownBtn);
			}

			toggleClass(dropdownBtn);
		}

		if (e.target.classList.contains('cms-link')) {
			e.preventDefault();
			const wrapper = document.querySelector('.service__main-content-cms');
			const btn = wrapper.querySelector('.drop-down-js');
			if (!btn.classList.contains('is-active')) {
				toggleClass(btn);
			}

			setTimeout(() => {
				scrollToAnchor.scroll(e);
			}, 500);
		}
	});

	document.addEventListener('DOMContentLoaded', () => {
		if (vars.isMobile()) {
			setTimeout(() => {
				checkActiveMenu();
			}, 1000);
		} else {
			checkActiveMenu();
		}
	});

	dropDownInput.forEach((el) => {
		el.addEventListener('click', replacePlaceHolder);
	});
}

export default {
	init,
	toggleClass,
};

